if (typeof Area !== " function") {
  window.Area = function (wrapper, duracion, data) {
    let box = new Box({
      size: { width: 600, height: 600 },
      padding: { top: 10, right: 15, bottom: 40, left: 80 },
    });

    let svg = null;

    let gEjeX = null;
    let gEjeY = null;
    let gMain = null;

    let color = d3
      .scaleOrdinal()
      .range([
        "#5778a4",
        "#e49444",
        "#d1615d",
        "#85b6b2",
        "#6a9f58",
        "#e7ca60",
        "#a87c9f",
        "#f1a2a9",
        "#967662",
        "#b8b0ac",
      ]);

    let escalaX = d3
      .scaleTime()
      .domain([new Date(2015, 0, 1), new Date(2025, 6, 1)])
      .range([0, box.content.width]);

    let escalaY = d3
      .scaleLinear()
      .domain([1, _.max(_.map(data, "superficie"))]) //TODO: Checar al rato
      .range([box.content.height, 0]);

    let lineGenerator = d3
      .line()
      .x((d) => escalaX(d.fecha))
      .y((d) => escalaY(d.superficie));

    let emptyLineGenerator = d3
      .line()
      .x((d) => escalaX(d.fecha))
      .y((d) => escalaY(0));

    let grupos = null;
    function setup() {
      data = d3.sort(
        data,
        ({ anio }) => anio,
        ({ fecha }) => fecha
      );

      let acumulados = d3
        .rollups(
          data,
          (xs) => d3.sum(xs, (x) => x.superficie),
          (d) => d.municipio,
          (d) => d.anio
        )
        .map(([k, v]) => ({ municipio: k, arreglo: v }));

      let arreglo = [];
      _.each(acumulados, function (d) {
        _.each(d.arreglo, function (a) {
          let obj = { municipio: d.municipio, anio: a[0], superficie: a[1] };
          arreglo.push(obj);
        });
      });

      grupos = d3.group(arreglo, (d) => d.anio);

      let municipios = _.uniq(_.map(arreglo, "municipio"));
      municipios.sort();

      crearSVG();
      crearLeyenda(municipios);
      main();
    }

    function crearSVG() {
      svg = wrapper
        .select("div.reducido")
        .append("svg")
        .attr("preserveAspectRatio", "xMidYMid")
        .attr("viewBox", `0 0 ${box.width} ${box.height}`);

      svg = svg.append("g");

      svg = svg
        .append("g")
        .attr(
          "transform",
          `translate(${box.padding.left}, ${box.padding.top})`
        );

      gEjeX = svg
        .append("g")
        .attr("transform", `translate(0, ${box.content.height})`)
        .attr("data-g", "gEjeX");
      gEjeY = svg.append("g").attr("data-g", "gEjeY");
      gMain = svg.append("g").attr("data-g", "gMain");

      gEjeY
        .append("text")
        .text("Hectáreas")
        .attr("font-size", "14px")
        .attr("fill", "#ffffff")
        .attr("text-anchor", "middle")
        .attr(
          "transform",
          `translate(-70,${escalaY(escalaY.domain()[1] / 2)})rotate(270)`
        );

      let anios = d3.extent(_.map(data, "anio"));

      let fechas = [];
      let anio = 0;
      for (anio = anios[0]; anio <= anios[1]; anio++) {
        fechas.push(new Date(anio, 6, 1));
      }

      gEjeX
        .call(
          d3
            .axisBottom(escalaX)
            .tickValues(fechas)
            .tickFormat(d3.timeFormat("%Y"))
        )
        .selectAll("text")
        .style("text-anchor", "middle");
    }

    function crearLeyenda(grupos) {
      color.domain(grupos);

      let lista = wrapper.select("ul.lineas__lista");
      let items = lista
        .selectAll("li.lineas__item")
        .data(grupos)
        .join("li")
        .attr("class", "lineas__item");

      let labels = items.append("label").html((d) => d);

      labels
        .append("input")
        .attr("type", "checkbox")
        .attr("class", "lineas__checkbox")
        .attr("checked", true)
        .style("accent-color", (d) => color(d))
        .on("change", actualizaAreas);
    }

    let keys = [];
    function main() {
      keys = _.uniq(_.map(data, (d) => d.municipio)); // list of group names

      let stackedData = d3
        .stack()
        .order(d3.stackOrderAscending)
        .keys(keys)
        .value(function (d, key) {
          let obj = _.find(d[1], { municipio: key }) || false;
          return obj ? obj.superficie : 0;
        })(grupos);

      let max = _.max(
        _.map(stackedData, function (d) {
          return _.max(_.map(d, (a) => a[1]));
        })
      );

      let formatoSuperficie = d3.format(",.0f");

      escalaY.domain([0, max]);

      gEjeY.call(
        d3
          .axisLeft(escalaY)
          .tickSizeOuter(0)
          .tickFormat((d) => `${formatoSuperficie(d)}`)
      );

      gMain
        .selectAll(".area")
        .data(stackedData, (d) => d.key)
        .join("path")
        .attr("class", "area")
        .attr("fill", "transparent")
        .attr("fill", (d) => color(d.key))
        .attr("stroke", (d) => color(d.key))
        .attr("stroke-width", 1)
        //.attr("d", (d) => lineGenerator(d[1]));
        .attr(
          "d",
          d3
            .area()
            .x(function (d, i) {
              return escalaX(new Date(d.data[0], 6, 1));
            })
            .y0(function (d) {
              return escalaY(d[0]);
            })
            .y1(function (d) {
              return escalaY(d[1]);
            })
        );
    }

    function actualizaAreas(e, o) {
      e.preventDefault();
      let checked = d3.select(this).property("checked");

      let ease = checked ? d3.easeQuadIn : d3.easeQuadOut;

      let municipios = [];

      wrapper
        .select("ul.lineas__lista")
        .selectAll("li.lineas__item")
        .each(function (d) {
          if (
            d3.select(this).select("input[type='checkbox']").property("checked")
          ) {
            municipios.push(d);
          }
        });

      let stackedData = d3
        .stack()
        .order(d3.stackOrderAscending)
        .keys(municipios)
        .value(function (d, key) {
          let obj = _.find(d[1], { municipio: key }) || false;
          return obj ? obj.superficie : 0;
        })(grupos);

      gMain
        .selectAll(".area")
        .data(stackedData, (d) => d.key)
        .join(
          (enter) =>
            enter

              .append("path")
              .attr("class", "area")
              .attr("fill", "transparent")
              .attr("fill", (d) => color(d.key))
              .attr("stroke", (d) => color(d.key))
              .attr("stroke-width", 1)

              .attr(
                "d",
                d3
                  .area()
                  .x(function (d, i) {
                    return escalaX(new Date(d.data[0], 6, 1));
                  })
                  .y0(function (d) {
                    return escalaY(d[0]);
                  })
                  .y1(function (d) {
                    return escalaY(d[0]);
                  })
              )
              .transition()
              .duration(duracion)
              .ease(ease)
              .attr(
                "d",
                d3
                  .area()
                  .x(function (d, i) {
                    return escalaX(new Date(d.data[0], 6, 1));
                  })
                  .y0(function (d) {
                    return escalaY(d[0]);
                  })
                  .y1(function (d) {
                    return escalaY(d[1]);
                  })
              ),
          (update) =>
            update
              .transition()
              .duration(duracion)
              .ease(ease)
              .attr(
                "d",
                d3
                  .area()
                  .x(function (d, i) {
                    return escalaX(new Date(d.data[0], 6, 1));
                  })
                  .y0(function (d) {
                    return escalaY(d[0]);
                  })
                  .y1(function (d) {
                    return escalaY(d[1]);
                  })
              ),
          (exit) =>
            exit
              .attr(
                "d",
                d3
                  .area()
                  .x(function (d, i) {
                    return escalaX(new Date(d.data[0], 6, 1));
                  })
                  .y0(function (d) {
                    return escalaY(d[0]);
                  })
                  .y1(function (d) {
                    return escalaY(d[1]);
                  })
              )
              .transition()
              .duration(duracion)
              .ease(ease)
              .attr(
                "d",
                d3
                  .area()
                  .x(function (d, i) {
                    return escalaX(new Date(d.data[0], 6, 1));
                  })
                  .y0(function (d) {
                    return escalaY(d[0]);
                  })
                  .y1(function (d) {
                    return escalaY(d[0]);
                  })
              )
              .remove()
        );
    }

    setup();
  };
}
